<!--
  - Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
  -->

<template>
  <button
    class="button search-button"
    :class="classes"
    title="Search for plant or article"
    @click="$emit('click')"
    :disabled="disabled"
  >
    <span class="icon">
      <search-icon v-if="!loading" />
      <Spinner v-if="loading"></Spinner>
    </span>
    <span>{{ $t("Search") }}</span>
  </button>
</template>
<script>
import SearchIcon from "@images/search-24px.svg";
import Spinner from "./../common/spinner";

export default {
  components: {
    SearchIcon,
    Spinner
  },
  computed: {
    classes() {
      let list = {};
      if (this.light) {
        list["is-light"] = true;
      } else {
        list["primary-color"] = true;
      }
      return list;
    }
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    light: {
      type: Boolean,
      default: true
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./../../styles/index";

.search-button {
  margin-left: 1rem;
  background-color: $primary-theme-color-light !important;

  &.primary-color {
    background-color: $primary-theme-color !important;
  }
}
</style>
